import { useTranslation } from 'react-i18next'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Menu, Space, Typography } from 'antd'

import { cartPage, findStorePage, wishlistPage } from 'src/routes/NamedRoutes'

import './Navbar.less'

const NavbarExternal = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Space direction="vertical" size="small">
      <Typography.Text className="font-lora--18 navbar-external__subtitle">
        {t('common:text.can_also')}
      </Typography.Text>
      <Menu mode="inline" inlineIndent={10} className="navbar__menu">
        <Menu.Item
          className="navbar__menu-item"
          icon={<ArrowRightOutlined />}
          key="cart"
        >
          <a href={cartPage()}>{t('common:navigation.view_cart')}</a>
        </Menu.Item>
        <Menu.Item
          className="navbar__menu-item"
          icon={<ArrowRightOutlined />}
          key="wishlist"
        >
          <a href={wishlistPage()}>{t('common:navigation.view_wishlist')}</a>
        </Menu.Item>
        <Menu.Item
          className="navbar__menu-item navbar__menu-item--big-text navbar__menu-item--nearest-store"
          icon={<ArrowRightOutlined />}
          key="find_store"
        >
          <a href={findStorePage()}>
            {t('common:navigation.find_store_appointment')}
          </a>
        </Menu.Item>
      </Menu>
    </Space>
  )
}

export default NavbarExternal
